<template>
  <v-card>
    <v-toolbar :color="$store.getters.toolbarColor" dark>
      <v-toolbar-title>Change Password</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <message :messages="messages"></message>
      <form>
        <v-text-field v-model="pwForm.password" :label="labels.password" type="password" :error-messages="errors.collect('password')" v-validate="'required|max:128'" ref="password" :data-vv-as="labels.password"></v-text-field>
        <v-text-field v-model="pwForm.cfmPassword" :label="labels.cfmPassword" type="password" :error-messages="errors.collect('cfmPassword')" v-validate="'required|confirmed:password'" ref="cfmPassword" :data-vv-as="labels.cfmPassword"></v-text-field>
        <v-btn color="primary" type="submit" @click.prevent="doChange" :loading="loading">Change Password</v-btn>
        <v-btn flat @click="$router.push({ name: 'login'})">Cancel</v-btn>
      </form>
    </v-card-text>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {
      labels: {
        password: 'Password*',
        cfmPassword: 'Confirm Password*'
      },
      pwForm: {
        password: '',
        cfmPassword: ''
      },
      loading: false
    }
  },
  methods: {
    doChange() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.resetMessages()
          const apiURI = this.$store.state.app.baseMenu.resetPassword
          if (apiURI) {
            this.loading = true
            const postForm = {
              forgetPwCode: this.id,
              password: this.pwForm.password
            }
            this.$http.post(apiURI, postForm)
              .then(response => {
                const { data } = response
                this.notify(data)
                this.$router.push({ name: 'login' })
              })
              .catch((error) => {
                const { data } = error.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
                this.loading = false
              })
          } else {
            this.errorMessage('Invalid API URL')
          }
        } else {
          this.promptFieldCheck()
        }
      })
    }
  },
  mounted() {
  },
  props: ['id'],
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
